import axios from "axios";
import { getBrowserInfo } from "@/shared/lib/browserInfo";
import { sendBrowserInfoOnError } from "./browser-info/api-browser-info";
import { captureException } from "@sentry/react";

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    captureException(error);

    if (error.response?.status === 401) {
      const errorId = error.response?.data?.error?.id;
      if (errorId) {
        const browserInfo = getBrowserInfo();
        sendBrowserInfoOnError(errorId, browserInfo);
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
